import React from 'react'
import {ImAppleinc} from 'react-icons/im'
import {VscLiveShare} from 'react-icons/vsc'
import {GiKite} from 'react-icons/gi'


const AboutUs = () => {
  return (
   <main className='transition duration-700'>
       <section className='bg-[#F6F6F6]'> 
          <div className='grid lg:grid-row-2 container pt-10 mx-auto xl:max-w-[1280px] px-4 md:px-6 lg:px-0'>
              <div className='lg:w-1/2 xl:w-2/5 md:w-3/4  mx-auto '> 
                  <h1 className='  md:text-center text-2xl text-center sm:px-6 md:px-0  sm:text-3xl md:text-4xl font-bold' > 
                      We are Connecting millions  of People with Calls, Chats and much more
                  </h1>
                  {/* <p className='mt-4  md:text-center md:text-sm lg:px-8'>  Spread love globally using social communication, support businesses, and promote talents.  </p>  */}
              </div> 

              <div className=' '> 
                  <div className='mt-4  '> 
                    <img className='image-cover mx-auto lg:max-h-[16rem]' src='./image/connecting.webp' alt=''/>
                   
                     {/* <img className='absolute top-[17rem] sm:top-[30rem] w-[12rem] hidden lg:flex   lg:top-[20rem] lg:left-[10rem]  lg:w-[18rem] ' src='./image/shade.png' alt='' />
                      <img className='absolute top-[50rem] sm:top-[30rem] w-[12rem] hidden lg:flex lg:top-[20rem] left-[18.5rem] lg:left-[35rem]  lg:w-[18rem] ' src='./image/shade.png' alt='' /> */}
                  </div>
              </div>

          </div>

       </section>

       <section  className='bg-[#fdfdfd]'> 
        <div className='grid lg:grid-cols-2 xl:max-w-[1280px] container mx-auto px-4 md:px-6  lg:px-0'> 
            <div className='lg:px-4 mt-10 '> 
                <div className=''>
                    <h1 className=' lg:mt-20 font-bold text-center lg:text-start text-2xl sm:text-3xl md:text-4xl'> About Us </h1>
                    <p className='mt-2 text-[0.9rem] sm:text-lg text-center lg:text-start '> Mslockdown world is a social network with an Algorithm built with the people’s best interests at heart. We aim to help people find new connections and share new memories with friends and families using pictures, videos, texts, voice calls, post, and stories.  </p>

                    <p className='mt-2 text-[0.9rem] sm:text-lg text-center lg:text-start '>
                       Our main goal is to spread love globally using social communication, support businesses, and promote talents. We earnestly desire to use our platform to change the global social experience for the better.
                    </p>
                </div>

                <div className='flex justify-center lg:justify-start text-[#ffffff] space-x-4 lg:mt-6 mt-10'> 
                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-1 hover:cursor-pointer rounded-md'>
                           
                         <ImAppleinc className='text-2xl mt-1 '> </ImAppleinc>
                          <div className='' > 
                              <h1 className='text-xs mt-0.5  text-start'> Download on the  </h1>
                              <h1 className='mt-[-4px] text-start text-sm'> App Store</h1>
                          </div>
                        </div>

                         <div className='flex  sm:w-36 w-fit px-1 h-10 hover:bg-primaryblue hover:text-[#ffffff] bg-[#000000]  hover:border-0 space-x-2 hover:cursor-pointer rounded-md'>
                           
                          <img className='h-6 mt-2 ml-2' src='./image/google.webp' alt='google play'/>
                          <div className='' > 
                              <h1 className='text-xs  mt-0.5 text-start'> GET IT ON </h1>
                              <h1 className='mt-[-4px] text-sm'> Google Play</h1>
                          </div>
                        </div>
                    </div>
            </div>

            <div> 
                <img className=' mt-16 w-[24rem] h-[25rem] ml-auto xl:ml-40 hidden lg:flex' src='./image/devices.webp' alt='Devices'/>
            </div>
           
        </div>
       </section>

       <section> 
        <div className='container xl:max-w-[1280px] mx-auto px-5 mt-10  sm:mt-16'>
            <div> 
                <div> 
                  <h1 className='text-center font-bold  text-2xl sm:text-3xl md:text-4xl'> Who We Are </h1>
                  <p className='lg:w-4/5 mx-auto  mt-2 text-[0.9rem] sm:text-lg text-center lg:text-start '>
                      At Mslockdown, we believe creating a unique space for people is the best and most secure way to improve global communication. We're committed to contributing to the pleasure of making new connections and friends throughout the globe. Here, everyone's voice matters, and reaching out to loved ones couldn't be any easier.

                  </p>
                </div>
            </div>

            <div className=' mt-10 flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:justify-between hover:cursor-pointer'> 
                <div className='bg-primaryblue pt-2 rounded-md w-[14rem] h-[17rem] mx-auto sm:w-[17rem]  sm:h-[15rem] text-[#ffffff]  '> 
                    <div className='bg-[#ffffff]  mt-4 rounded-full h-10 w-10 items-center flex justify-center mx-auto'> 
                        <img className='h-6 w-6 ' src='./image/verify.png' alt=''/>
                    </div>

                    <h1 className='mt-2 text-center font-semibold text-lg sm:text-xl '> We are Smart </h1>
                    <p className='text-[0.8rem] text-center  mt-1 px-4 '> We work with a strategic system, make top-notch decisions, and solve communication problems with much accuracy through the help of our positive, driven team.</p>
                </div>

                <div className='bg-primaryblue pt-2 rounded-md w-[14rem] h-[17rem] mx-auto sm:w-[17rem]  sm:h-[15rem] text-[#ffffff] '> 
                    <div className='bg-[#ffffff]  mt-4 rounded-full h-10 w-10 items-center flex justify-center mx-auto'> 
                        <img className='h-6 w-6 ' src='./image/kind.png' alt=''/>
                    </div>

                    <h1 className='mt-2 text-center font-semibold text-lg sm:text-xl '> We Are Kind </h1>
                    <p className='text-[0.8rem] text-center mt-1 px-4 '> We show empathy and exhibit trust through honesty and integrity. This is what we represent.</p>
                </div>

                <div className='bg-primaryblue pt-2 rounded-md w-[14rem] h-[17rem] mx-auto sm:w-[17rem]  sm:h-[15rem] text-[#ffffff] '> 
                    <div className='bg-[#ffffff]  mt-4 rounded-full h-10 w-10 items-center flex justify-center mx-auto'> 
                        <img className='h-6 w-6 ' src='./image/creative.png' alt=''/>
                    </div>

                    <h1 className='mt-2 text-center font-semibold text-lg sm:text-xl '> We Are Creative  </h1>
                    <p className='text-[0.8rem] text-center mt-1 px-4'> We have a strong desire to learn while exposing our creativity and innovation. We are resilient and gracefully handle ambivalence.</p>
                </div>
            </div>

        </div>
       </section>

       <section className='bg-[#D6F2FE] mt-10'> 
          <div className='container xl:max-w-[1280px] pt-4 mx-auto'> 
             <div className='pb-10 md:flex md:justify-between  lg:px-6'> 
                  <div className='bg-[#ffffff] w-[15rem] sm:w-[20rem]   sm:h-[16rem] mt-4 pt-4 text-start shadow-lg px-5 mx-auto  rounded-md pb-2 h-[15rem]'> 
                      <VscLiveShare className=' mx-auto text-[#3367D6] text-3xl'/>
                      <h1 className=' lg:ml-6 lg:mt-3 font-bold sm:text-lg text-center'>     Our <span className='text-[#3367D6]'> Vision </span>      </h1>
                      <p className=' text-xs sm:text-sm font-semibold text-center lg:h-[6rem] lg:text-start lg:ml-6 mt-1'> We aspire to provide exceeding expectations to improve the system of social conversations all over the world, it is our dream for people to experience emotional connections without having to be in the same room. </p>
                      
                  </div>


                   <div className='bg-[#ffffff] w-[15rem] sm:w-[20rem]   sm:h-[16rem] mt-4 pt-4 text-start shadow-lg px-5 mx-auto  rounded-md pb-2 h-[15rem]'> 
                      <GiKite className=' mx-auto text-[#3367D6] text-3xl'/>
                       <h1 className=' lg:mt-3 lg:ml-6 font-bold sm:text-lg text-center '>     Our <span className='text-[#3367D6]'> Mission </span>      </h1>
                      <p className=' text-xs sm:text-sm font-semibold lg:h-[6rem]  text-center lg:text-start lg:ml-6 mt-1'> We aim to improve the chivalry of social conversations all over the world. We are also committed to expanding collective openness and social health while providing an uninterrupted chatting experience from anywhere around the globe. </p>
                     
                  </div>

             </div>
          </div>
       </section>
  </main> 
  )
}

export default AboutUs